import React, { Component } from 'react';
import { ApiClientResponseError } from '@oh-auth/api-client';
import { ErrorCode } from '@oh-auth/dto';
import Alert from '@material-ui/lab/Alert';

import i18n from '../i18n';
import { RefreshTokens } from './RefreshTokens';

interface ErrorBoundaryProps {
	// refreshTokens: (cb: () => any) => void;
}

interface ErrorBoundaryState {
	error: boolean;
	refreshToken: boolean;
}

export class ErrorBoundary extends Component<
	ErrorBoundaryProps,
	ErrorBoundaryState
> {
	state = {
		error: false,
		refreshToken: false,
	};

	static getDerivedStateFromError(e: any) {
		console.log(e);
		if (e instanceof ApiClientResponseError) {
			const {
				params: { error, error_details },
			} = e;
			console.log({ error, error_details });
			if (error === ErrorCode.INVALID_TOKEN && error_details.expired) {
				console.log({ refreshToken: true });
				return { refreshToken: true };
			}
		}
		return { error: true };
	}

	// componentDidUpdate(
	// 	prevProps: ErrorBoundaryProps,
	// 	prevState: ErrorBoundaryState
	// ) {
	// 	console.log(
	// 		'refresh',
	// 		!prevState.refreshToken && this.state.refreshToken
	// 	);
	// 	if (!prevState.refreshToken && this.state.refreshToken) {
	// 		this.props.refreshTokens();
	// 		this.setState({ refreshToken: false });
	// 	}
	// }

	handleRefreshed = () => {
		this.setState({ refreshToken: false });
	};

	render() {
		const { children } = this.props;
		return this.state.error ? (
			<Alert severity="warning">{i18n.t('errorBoundary.message')}</Alert>
		) : this.state.refreshToken ? (
			<RefreshTokens
				// refreshTokens={this.props.refreshTokens}
				onRefreshed={this.handleRefreshed}
			/>
		) : (
			children
		);
	}
}

export default ErrorBoundary;
